import { colors, bgs } from './colors';
import { h13_Regular, h16_Regular } from './fonts';
import vars from './vars';

const { textWhite, lightGrey, textColor20 } = colors;
const { lightGrayColor } = bgs;
let placeholderFont = h16_Regular;
if (window.innerWidth < 800) {
  if (window.innerWidth < 480) {
    placeholderFont = h13_Regular;
  }
}
const ftsThemeMD = {
  searchContainerStyle: {
    flexDirection: 'row',
    paddingRight: 15,
    paddingLeft: 15,
    alignItems: 'center',
    borderRadius: 10,
    width: 260, //260
    height: 40,
    backgroundColor: vars.colors.white,
    //borderColor: textColor20,
    border: '1px solid rgba(191,201,202,1)',
  },
  inputStyle: {
    ...placeholderFont,
    flex: 1,
    outline: 'none',
    borderWidth: 0,
    backgroundColor: vars.colors.white,
  },
  searchImageStyle: {
    opacity: 0.5,
    width: 20,
    height: 20,
  },
  crossImageStyle: {
    width: 20,
    height: 20,
  },
};

const ftsThemeSM = {
  searchContainerStyle: {
    flexDirection: 'row',
    paddingRight: 10,
    paddingLeft: 5,
    alignItems: 'center',
    borderRadius: 10,
    backgroundColor: vars.colors.white,
    marginRight: 5,
    paddingTop: 3,
    paddingBottom: 3,
    marginTop: 14,
  },
  inputStyle: {
    ...placeholderFont,
    height: 30,
    paddingLeft: 10,
    outline: 'none',
    border: `0px solid ${textWhite}`,
    backgroundColor: vars.colors.white,
  },
  searchImageStyle: {
    opacity: 0.5,
    width: 17,
    height: 17,
  },
};

export { ftsThemeSM, ftsThemeMD };
